var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16683 0.833374H17.3335C18.3898 0.833374 19.1668 1.61045 19.1668 2.66671V11.8334C19.1668 12.8896 18.3898 13.6667 17.3335 13.6667H13.6668V17.3334C13.6668 18.3896 12.8898 19.1667 11.8335 19.1667H2.66683C1.61057 19.1667 0.833496 18.3896 0.833496 17.3334V8.16671C0.833496 7.11045 1.61057 6.33337 2.66683 6.33337H6.3335V2.66671C6.3335 1.61045 7.11057 0.833374 8.16683 0.833374ZM6.3335 8.16671H2.66683V17.3334H11.8335V13.6667H8.16683C7.11057 13.6667 6.3335 12.8896 6.3335 11.8334V8.16671ZM8.16683 2.66671V11.8334H17.3335V2.66671H8.16683Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAlt);
export default __webpack_public_path__ + "static/media/copy-alt.78ded2a6.svg";
export { ForwardRef as ReactComponent };